import styled from 'styled-components'
import theme from 'theme_'

// TODO Svg sizes will be fixed with HostType images
export const JobHostTypeWrapper = styled.div`
  svg {
    width: 40px;
    height: 15px;
  }
`

export const JobHostSoftwareVersion = styled.div`
  padding: 0;
  font-weight: 700;
  color: ${theme.colors.otterWarmBlack};
`

export const JobNamesWrapper = styled.div`
  margin-left: ${theme.spacing.base};
`

export const JobNamesJobName = styled.div`
  margin-bottom: 5px;
  color: ${theme.colors.moreGrey};
`

export const JobNamesHomeName = styled.div`
  color: ${theme.colors.otterWarmBlack};
`
